const INITIAL_SAFE_CONCERN = {
	safe: false,
	concern: false
};

export const INITIAL_STATE = {
	activity: {
		diving: {
			title: 'Diving',
			value: false
		},
		topside: {
			title: 'Topside',
			value: false
		},
		travel: {
			title: 'Travel',
			value: false
		},
		shop: {
			title: 'Shop',
			value: false
		},
		other: {
			title: 'Other',
			value: false
		}
	},
	type_of_observation: {
		self_observation: {
			title: 'Self-Observation',
			value: false
		},
		other_person: {
			title: 'Other Person',
			value: false
		},
		short_service: {
			title: 'Short Service',
			value: false
		},
		suggestion: {
			title: 'Suggestion',
			value: false
		},
		near_miss: {
			title: 'Near Miss',
			value: false
		}
	},
	conditions: {
		personal_protective_equipment: {
			title: 'Personal Protective Equipment',
			fields: {
				eye_face_protection: {
					title: 'Eye/Face Protection',
					...INITIAL_SAFE_CONCERN
				},
				head_protection: {
					title: 'Head Protection',
					...INITIAL_SAFE_CONCERN
				},
				hand_protection: {
					title: 'Hand Protection',
					...INITIAL_SAFE_CONCERN
				},
				footwear: {
					title: 'Footwear',
					...INITIAL_SAFE_CONCERN
				},
				hearing_protection: {
					title: 'Hearing Protection',
					...INITIAL_SAFE_CONCERN
				},
				pfd_use_condition: {
					title: 'PDF Use/Condition',
					...INITIAL_SAFE_CONCERN
				},
				fall_protection: {
					title: 'Fall Protection',
					...INITIAL_SAFE_CONCERN
				},
				respirator: {
					title: 'Respirator',
					...INITIAL_SAFE_CONCERN
				}
			}
		},
		body_position_mechanics: {
			title: 'Body Position / Mechanics',
			fields: {
				line_of_fire: {
					title: 'Line of Fire',
					...INITIAL_SAFE_CONCERN
				},
				walking: {
					title: 'Walking',
					...INITIAL_SAFE_CONCERN
				},
				climbing: {
					title: 'Climbing',
					...INITIAL_SAFE_CONCERN
				},
				eyes_on_work: {
					title: 'Eyes on Work',
					...INITIAL_SAFE_CONCERN
				},
				lifting_carrying: {
					title: 'Lifting/Carrying',
					...INITIAL_SAFE_CONCERN
				},
				slip_trip_hazards: {
					title: 'Slip/Trip Hazards',
					...INITIAL_SAFE_CONCERN
				},
				pinch_points: {
					title: 'Pinch Points',
					...INITIAL_SAFE_CONCERN
				},
				proper_pace: {
					title: 'Proper Pace',
					...INITIAL_SAFE_CONCERN
				}
			}
		},
		tools_equipment: {
			title: 'Tools & Equipment',
			fields: {
				selection_use: {
					title: 'Selection & Use',
					...INITIAL_SAFE_CONCERN
				},
				condition: {
					title: 'Condition',
					...INITIAL_SAFE_CONCERN
				},
				guards: {
					title: 'Guards',
					...INITIAL_SAFE_CONCERN
				},
				cords_lines: {
					title: 'Cords / Lines',
					...INITIAL_SAFE_CONCERN
				},
				vehicle_boat: {
					title: 'Vehicle / Boat',
					...INITIAL_SAFE_CONCERN
				},
				rigging: {
					title: 'Rigging',
					...INITIAL_SAFE_CONCERN
				},
				fire_first_aid: {
					title: 'Fire / First Aid',
					...INITIAL_SAFE_CONCERN
				},
				sds_reviewed: {
					title: 'SDS Reviewed',
					...INITIAL_SAFE_CONCERN
				}
			}
		},
		work_environment: {
			title: 'Work Environment',
			fields: {
				hazards_id_d: {
					title: "Hazards ID'd",
					...INITIAL_SAFE_CONCERN
				},
				lockout_tagout: {
					title: 'Lockout/Tagout',
					...INITIAL_SAFE_CONCERN
				},
				lighting_visibility: {
					title: 'Lighting/Visibility',
					...INITIAL_SAFE_CONCERN
				},
				signs_barricades: {
					title: 'Signs/Barricades',
					...INITIAL_SAFE_CONCERN
				},
				housekeeping: {
					title: 'Housekeeping',
					...INITIAL_SAFE_CONCERN
				},
				weather: {
					title: 'Weather',
					...INITIAL_SAFE_CONCERN
				},
				adjacent_work: {
					title: 'Adjacent Work',
					...INITIAL_SAFE_CONCERN
				},
				communication: {
					title: 'Communication',
					...INITIAL_SAFE_CONCERN
				}
			}
		}
	},
	what: '',
	why: '',
	on_site_solution: '',
	hazard_status: {
		completed: false,
		pending: false
	},
	hazard_status_comment: '',
	near_misses: {
		injury_illness: {
			title: 'Injury / Illness',
			value: false
		},
		property_damage: {
			title: 'Property Damage',
			value: false
		},
		motor_vehicle: {
			title: 'Motor Vehicle',
			value: false
		},
		environmental: {
			title: 'Environmental',
			value: false
		}
	},
	near_miss_description: '',
	project_location: '',
	observer_name: '',
	date: {
		manual: false,
		date: Date.now()
	},
	photos: []
};
